export { default as Categoria } from './Categoria';
export { default as CategoriaConfig } from './CategoriaConfig';
